export const GET_APPLICATIONS = "GET_APPLICATIONS";
export const GET_APPLICATIONS_ID = "GET_APPLICATIONS_ID";
